export class BaseWebComponentElementFactory {
  protected map = new Map<string | number, string>();

  build<T extends HTMLElement>(type: string | number): T {
    const element = this.getType(type);
    return (document.createElement(element) as unknown) as T;
  }

  getType(type: string | number): string {
    if (this.map.has(type)) {
      const element = this.map.get(type);
      if (!element) {
        throw new Error(`Type ${type} cannot be built by web components element factory`);
      }
      return element;
    }
    throw new Error(`Type ${type} cannot be built by web components element factory`);
  }
}
